export type VerticalProfileArchetype =
  | 'hero_product'
  | 'hero_lifestyle'
  | 'offer_badge'
  | 'text_forward'
  | 'regulated';

export interface VerticalProfileImagerySubject {
  title: string;
  description: string;
  tags: string[];
}

export interface VerticalProfileImagery {
  required: 'mandatory' | 'recommended' | 'optional';
  precision: number;
  precision_label: string;
  subjects: VerticalProfileImagerySubject[];
  fidelity_notes: string;
  avoid_images: string[];
  shooting_guidance: string;
  ai_image_notes: string;
}

export interface VerticalProfileGenerationPolicy {
  level: 'none' | 'background_only' | 'full';
  max_generated_area_frac: number;
  require_provenance: boolean;
}

export interface VerticalProfilePayload {
  profile_id: string;
  version: number;
  name: string;
  archetype: VerticalProfileArchetype;
  group: string;
  industries: string[];
  media_types: string[];
  purposes: string[];
  required_elements: string[];
  required_roles: string[];
  tone_guidance: string;
  key_visual_rules: string[];
  avoidances: string[];
  imagery: VerticalProfileImagery;
  copy_prompt: string;
  generation_policy: VerticalProfileGenerationPolicy;
}

export interface VerticalProfile {
  id: string;
  profile_id: string;
  version: number | null;
  version_id: string | null;
  payload: VerticalProfilePayload;
  created_at: string;
  updated_at: string;
}

export interface VerticalProfileVersionSummary {
  id: string;
  version: number;
  created_by: string;
  created_by_email: string;
  created_at: string;
  change_note: string;
}

export interface VerticalProfileWritePayload {
  profile_id?: string;
  name?: string;
  archetype?: VerticalProfileArchetype;
  group?: string;
  industries?: string[];
  media_types?: string[];
  purposes?: string[];
  required_elements?: string[];
  required_roles?: string[];
  tone_guidance?: string;
  key_visual_rules?: string[];
  avoidances?: string[];
  imagery?: VerticalProfileImagery;
  copy_prompt?: string;
  generation_policy?: VerticalProfileGenerationPolicy;
  change_note?: string;
}

export interface VerticalProfileVersionDetail extends VerticalProfileVersionSummary {
  payload: VerticalProfilePayload;
}

export const VERTICAL_PROFILE_ARCHETYPE_OPTIONS: VerticalProfileArchetype[] = [
  'hero_product',
  'hero_lifestyle',
  'offer_badge',
  'text_forward',
  'regulated',
];

export const IMAGERY_REQUIRED_OPTIONS = ['mandatory', 'recommended', 'optional'] as const;

export const CREATIVE_ROLE_OPTIONS = [
  'background',
  'hero',
  'logo',
  'headline',
  'body',
  'cta',
  'legal',
  'accent',
] as const;
